/**
 * Typed endpoints for /coach/admin/email-test-send/*.
 *
 * Transport, error class and status mapping come from `src/api/client.ts`
 * (ADR-0056), including this module's two contributions to it: the 429 →
 * `RATE_LIMITED` and 502 → `PROVIDER_ERROR` mappings, and the structured
 * `detail` shape. The send-test endpoint deliberately surfaces the
 * provider's own failure text on a 502 rather than swallowing it — that
 * diagnostic IS the feature, so the transport unwraps `{code, message}`
 * instead of putting "[object Object]" in front of the operator.
 */
import { request } from '../api/client.js'
import type { SendTestRequest, SendTestResponse, TemplatesResponse } from './types.js'

const BASE = '/coach/admin/email-test-send'

export const adminEmailTestSendClient = {
  async templates(): Promise<TemplatesResponse> {
    return request<TemplatesResponse>(`${BASE}/templates`, { method: 'GET' })
  },

  /** Sends one real email to an allowlisted operator address. */
  async sendTest(body: SendTestRequest): Promise<SendTestResponse> {
    return request<SendTestResponse>(`${BASE}/send-test`, {
      method: 'POST',
      body: JSON.stringify(body),
    })
  },
}
